import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiUploadCloud, FiX } from "react-icons/fi";
import { toast } from "react-toastify";

const DeveloperForm = ({
  initialData = null,
  onSubmit,
  onCancel,
  requireImage = true,
}) => {
  const [form, setForm] = useState({
    fullName: "",
    position: "",
    phoneNumber: "",
    bio: "",
    gitUrl: "",
    instagramUrl: "",
    linkedinUrl: "",
    telegramUsername: "",
    file: null,
  });

  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm({
        fullName: initialData.fullName || "",
        position: initialData.position || "",
        phoneNumber: initialData.phoneNumber || "",
        bio: initialData.bio || "",
        gitUrl: initialData.gitUrl || "",
        instagramUrl: initialData.instagramUrl || "",
        linkedinUrl: initialData.linkedinUrl || "",
        telegramUsername: initialData.telegramUsername || "",
        file: null,
      });
      setImagePreview(initialData.imageUrl || null);
    } else {
      setForm({
        fullName: "",
        position: "",
        phoneNumber: "",
        bio: "",
        gitUrl: "",
        instagramUrl: "",
        linkedinUrl: "",
        telegramUsername: "",
        file: null,
      });
      setImagePreview(null);
    }
  }, [initialData]);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024)
        return toast.error("Rasm 5MB dan kichik bo‘lishi kerak");
      setForm((prev) => ({ ...prev, file }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const removeImage = (e) => {
    e.stopPropagation();
    setForm((prev) => ({ ...prev, file: null }));
    setImagePreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !form.fullName.trim() ||
      !form.position.trim() ||
      !form.phoneNumber.trim()
    ) {
      return toast.error("Majburiy maydonlar to‘ldirilishi kerak");
    }
    if (requireImage && !form.file && !imagePreview) {
      return toast.error("Rasm majburiy");
    }

    onSubmit(form);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="banner-form"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="form-grid">
        <div className="form-item">
          <label>Ism Familya *</label>
          <input
            name="fullName"
            value={form.fullName}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, fullName: e.target.value }))
            }
            required
          />
        </div>
        <div className="form-item">
          <label>Lavozimi *</label>
          <input
            name="position"
            value={form.position}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, position: e.target.value }))
            }
            required
          />
        </div>
        <div className="form-item">
          <label>Telefon raqam *</label>
          <input
            name="phoneNumber"
            value={form.phoneNumber}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, phoneNumber: e.target.value }))
            }
            required
          />
        </div>
        <div className="form-item">
          <label>Bio (ixtiyoriy)</label>
          <textarea
            rows="3"
            value={form.bio}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, bio: e.target.value }))
            }
          />
        </div>
        <div className="form-item">
          <label>GitHub</label>
          <input
            value={form.gitUrl}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, gitUrl: e.target.value }))
            }
          />
        </div>
        <div className="form-item">
          <label>Instagram</label>
          <input
            value={form.instagramUrl}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, instagramUrl: e.target.value }))
            }
          />
        </div>
        <div className="form-item">
          <label>LinkedIn</label>
          <input
            value={form.linkedinUrl}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, linkedinUrl: e.target.value }))
            }
          />
        </div>
        <div className="form-item">
          <label>Telegram</label>
          <input
            value={form.telegramUsername}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, telegramUsername: e.target.value }))
            }
          />
        </div>

        <div className="form-item">
          <label>Rasm {requireImage ? "*" : ""}</label>
          <div className="image-upload-box">
            {imagePreview ? (
              <div className="image-preview-wrapper">
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "cover",
                    borderRadius: 14,
                  }}
                />
                <motion.button
                  type="button"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  className="remove-image-btn"
                  onClick={removeImage}
                >
                  <FiX size={18} />
                </motion.button>
              </div>
            ) : (
              <motion.label
                htmlFor="devImage"
                className="upload-area"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <FiUploadCloud size={44} color="#00c853" />
                <p>Rasm yuklash</p>
                <span>JPG, PNG • Maks 5MB</span>
              </motion.label>
            )}
            <input
              id="devImage"
              type="file"
              accept="image/*"
              hidden
              onChange={handleImage}
            />
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="save">
            {initialData ? "Yangilash" : "Qo‘shish"}
          </button>
          <button type="button" className="cancel" onClick={onCancel}>
            Bekor qilish
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default DeveloperForm;
